import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { OnlineApplicationService } from '../services/online-application.service'
import { ToastService } from 'src/app/core/ui/notification/toast.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
import { NgxSpinnerService } from "ngx-spinner";
import { PlatformService } from 'src/app/core/platform/platform.service';

@Component({
  selector: 'app-online-application',
  templateUrl: './online-application.component.html',
  styleUrls: ['./online-application.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineApplicationComponent implements OnInit {
  @ViewChild('dangerTpl') dangerTpl: TemplateRef<any> | undefined;
  @ViewChild('popoverContent') popoverContent: TemplateRef<any> | undefined;
  // @ViewChild('documents') documents: ElementRef<any> | undefined;
  constructor(
    private onlineApplicationService: OnlineApplicationService,
    private toastService: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    protected activatedRoute: ActivatedRoute,
    public router: Router,
    protected titleService: Title,
    private metaService: Meta,
    private responsiveService: ResponsiveService,
    private spinner: NgxSpinnerService,
    private platformService: PlatformService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const doc = this.responsiveService.getDocument()//TODO: change here
    if (doc && doc.scrollingElement) {
      doc.scrollingElement.scrollTop = 0;
    }
    this.titleService.setTitle('Michigan Property Management | Rental Property Management Company in Michigan');
    this.metaService.updateTag(
      { name: 'keywords', content: `Property Management Company, Rental Property Management, Property Management Services` }
    );
    this.metaService.updateTag(
      { name: 'description', content: `Michigan Based North Bloomfield Properties Management Company offers Rental Property Management Services for Property Owners and Tenants in the Michigan area.` }
    );
    this.step = 1
    this.onlineApplicationForm4.controls['submit_date'].setValue(this.submitDate)
    if (this.activatedRoute.snapshot.params.id && this.activatedRoute.snapshot.params.address) {
      this.onlineApplicationForm1.controls['pro_address1'].setValue(`${this.activatedRoute.snapshot.params.address}`)
      this.readonly = true
    }
    if (this.platformService.isPlatformBrowser) {
      this.onlineApplicationService.getDocumentType().subscribe((result) => {
        this.doc_types = result.data
      })
    }
  }
  readonly: boolean = false;
  step: number = 1;
  onlineApplicationForm1: FormGroup = this.onlineApplicationService.getOnlineApplicationForm1();
  onlineApplicationForm2: FormGroup = this.onlineApplicationService.getOnlineApplicationForm2();
  onlineApplicationForm3: FormGroup = this.onlineApplicationService.getOnlineApplicationForm3();
  onlineApplicationForm4: FormGroup = this.onlineApplicationService.getOnlineApplicationForm4();
  selectedFiles: File[] = [];
  progressInfos: any[] = [];
  isCoApplicat: boolean = false;
  submitDate = new Date().toISOString().substring(0, 10)

  doc_types: any[] = [
    {
      "id": 5,
      "title": "Child Support"
    },
    {
      "id": 1,
      "title": "Drivers License Image"
    },
    {
      "id": 4,
      "title": "Letter of income from current employer"
    },
    {
      "id": 2,
      "title": "Pay Stub"
    },
    {
      "id": 10,
      "title": "Recent Bank Statement"
    },
    {
      "id": 9,
      "title": "Section 8 Paperwork"
    },
    {
      "id": 8,
      "title": "Social Security Document"
    },
    {
      "id": 6,
      "title": "Spousal Support"
    },
    {
      "id": 3,
      "title": "Tax Document"
    },
    {
      "id": 7,
      "title": "Unemployment"
    }
  ]
  onlineApplication1() {
    if (this.onlineApplicationForm1.valid) {
      // console.log('onlineApplicationForm1 Form', this.onlineApplicationForm1.value)
      this.onlineApplicationForm1.reset(this.onlineApplicationForm1.value);
      this.step = this.step + 1
      const win = this.responsiveService.getWindow()
      console.log('win...',win)
      if (win) {
        console.log('inside...if',win)
        setTimeout(()=>{
          win.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        },700)
        
      }

    } else {
      this.onlineApplicationForm1.markAllAsTouched();
      const keys = Object.keys(this.onlineApplicationForm1.controls);
      for (const key of keys) {
        this.onlineApplicationForm1.get(key)?.markAsDirty();
      }
    }
    // this.step = this.step + 1
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }

  onlineApplication2() {
    if (this.onlineApplicationForm2.valid) {
      console.log('onlineApplicationForm2 Form', this.onlineApplicationForm2.value)
      this.isCoApplicat = !Object.values(this.onlineApplicationForm2.value).every((elem:any) => [null,""].indexOf(elem) > -1)
      console.log(this.isCoApplicat)
      this.onlineApplicationForm2.reset(this.onlineApplicationForm2.value);
      this.step = this.step + 1
      const win = this.responsiveService.getWindow()
      setTimeout(()=>{
        if (win) {
          win.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      },700)
      
    } else {
      // this.showDanger();
      this.onlineApplicationForm2.markAllAsTouched();
      const keys = Object.keys(this.onlineApplicationForm2.controls);
      for (const key of keys) {
        this.onlineApplicationForm2.get(key)?.markAsDirty();
      }
    }
    // this.step=this.step+1
    // window.scrollTo({
    //   top: 0, 
    //   left: 0, 
    //   behavior: 'smooth' 
    //  });
  }

  onlineApplication3() {
    if (this.onlineApplicationForm3.valid) {
      // console.log('onlineApplicationForm3 Form', this.onlineApplicationForm3.value)
      this.onlineApplicationForm3.reset(this.onlineApplicationForm3.value);
      this.step = this.step + 1
      const win = this.responsiveService.getWindow()
      if (win) {
        setTimeout(()=>{
          win.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        },700)
      }
    } else {
      // this.showDanger();
      this.onlineApplicationForm3.markAllAsTouched();
      const keys = Object.keys(this.onlineApplicationForm3.controls);
      for (const key of keys) {
        this.onlineApplicationForm3.get(key)?.markAsDirty();
      }
    }
    // this.step=this.step+1
    // window.scrollTo({
    //   top: 0, 
    //   left: 0, 
    //   behavior: 'smooth' 
    //  });
  }

  onlineApplication4() {
    console.log('111')
    console.log( this.onlineApplicationForm4)
    if (this.onlineApplicationForm4.valid) {
      console.log('222')
      this.recaptchaV3Service.execute('submit').subscribe(
        async token => {
          this.spinner.show();
          const data = {
            Pro_address1: this.onlineApplicationForm1.value['pro_address1'],
            Pro_address2: this.onlineApplicationForm1.value['pro_address2'],
            Agent_Name: this.onlineApplicationForm1.value['agent_name'],
            Agent_Phone: this.onlineApplicationForm1.value['agent_phone'],
            Agent_Email: this.onlineApplicationForm1.value['agent_email'],
            name: this.onlineApplicationForm1.value['name'],
            surname: this.onlineApplicationForm1.value['surname'],
            username: this.onlineApplicationForm1.value['username'],
            work_phone: this.onlineApplicationForm1.value['work_phone'],
            home_phone: this.onlineApplicationForm1.value['home_phone'],
            Cell: this.onlineApplicationForm1.value['cell_phone'],
            Occupation: this.onlineApplicationForm1.value['occupation'],
            Company_Name: this.onlineApplicationForm1.value['company_name'],
            Length_of_employment: this.onlineApplicationForm1.value['length_of_employment'],
            Monthly_net_income: this.onlineApplicationForm1.value['monthly_net_income'],
            Other_monthly_income: this.onlineApplicationForm1.value['other_monthly_income'],
            Social_Security_Number: this.onlineApplicationForm1.value['social_security_number'],
            Drivers_License_Number: this.onlineApplicationForm1.value['drivers_license_number'],
            Birthdate: this.onlineApplicationForm1.value['birth_date'],
            Savings_account_bank: this.onlineApplicationForm1.value['savings_account_bank'],
            Savings_account_branch: this.onlineApplicationForm1.value['saving_branch'],
            Savings_account_no: this.onlineApplicationForm1.value['saving_account_number'],
            Checking_account_bank: this.onlineApplicationForm1.value['checking_account_bank'],
            Checking_account_branch: this.onlineApplicationForm1.value['checking_branch'],
            Checking_account_no: this.onlineApplicationForm1.value['checking_account_number'],
            address: this.onlineApplicationForm1.value['current_address1'],
            place: this.onlineApplicationForm1.value['current_address2'],
            city: this.onlineApplicationForm1.value['city'],
            state: this.onlineApplicationForm1.value['state'],
            zipcode: this.onlineApplicationForm1.value['zipcode'],
            country: this.onlineApplicationForm1.value['country'],
            Howlong_at_this_address: this.onlineApplicationForm1.value['howlong_at_this_address'],
            Rent: this.onlineApplicationForm1.value['rent'],
            Reason_for_moving: this.onlineApplicationForm1.value['reason_for_moving'],
            Owner: this.onlineApplicationForm1.value['owner'],
            Phone: this.onlineApplicationForm1.value['phone'],
            Emergency_Contact_Name: this.onlineApplicationForm1.value['emergency_contact_name'],
            Emergency_Contact_Phone: this.onlineApplicationForm1.value['emergency_contact_phone'],
            Is_Pet: this.onlineApplicationForm1.value['is_pet'],
            Type_Of_Pet: this.onlineApplicationForm1.value['type_of_pet'],
            Pet_Description: this.onlineApplicationForm1.value['pet_description'],
            Move_on: this.onlineApplicationForm1.value['move_on'],
            Prev_Address1: this.onlineApplicationForm1.value['prev_address1'],
            Prev_Address2: this.onlineApplicationForm1.value['prev_address2'],
            Prev_City: this.onlineApplicationForm1.value['prev_city'],
            Prev_State: this.onlineApplicationForm1.value['prev_state'],
            Prev_Zip: this.onlineApplicationForm1.value['prev_zip'],
            Prev_Country: this.onlineApplicationForm1.value['prev_country'],
            Comments: this.onlineApplicationForm1.value['additional_comments'],
            Co_First_Name: this.onlineApplicationForm2.value['co_name'],
            Co_Last_Name: this.onlineApplicationForm2.value['co_surname'],
            Co_Email: this.onlineApplicationForm2.value['co_username'],
            Co_Home_Phone: this.onlineApplicationForm2.value['co_home_phone'],
            Co_Work_Phone: this.onlineApplicationForm2.value['co_work_phone'],
            Co_Cell: this.onlineApplicationForm2.value['co_cell_phone'],
            Co_Occupation: this.onlineApplicationForm2.value['co_occupation'],
            Co_Company_Name: this.onlineApplicationForm2.value['co_company_name'],
            Co_Length_of_employment: this.onlineApplicationForm2.value['co_length_of_employment'],
            Co_Monthly_net_income: this.onlineApplicationForm2.value['co_monthly_net_income'],
            Co_Other_monthly_income: this.onlineApplicationForm2.value['co_other_monthly_income'],
            Co_Social_Security_Number: this.onlineApplicationForm2.value['co_social_security_number'],
            Co_Drivers_License_Number: this.onlineApplicationForm2.value['co_drivers_license_number'],
            Co_Birthdate: this.onlineApplicationForm2.value['co_birth_date'],
            Co_Savings_account_bank: this.onlineApplicationForm2.value['co_savings_account_bank'],
            Co_Savings_account_branch: this.onlineApplicationForm2.value['co_saving_branch'],
            Co_Savings_account_no: this.onlineApplicationForm2.value['co_saving_account_number'],
            Co_Checking_account_bank: this.onlineApplicationForm2.value['co_checking_account_bank'],
            Co_Checking_account_branch: this.onlineApplicationForm2.value['co_checking_branch'],
            Co_Checking_account_no: this.onlineApplicationForm2.value['co_checking_account_number'],
            Co_Address1: this.onlineApplicationForm2.value['co_current_address1'],
            Co_Address2: this.onlineApplicationForm2.value['co_current_address2'],
            Co_City: this.onlineApplicationForm2.value['co_city'],
            Co_State: this.onlineApplicationForm2.value['co_state'],
            Co_Zip: this.onlineApplicationForm2.value['co_zipcode'],
            Co_Country: this.onlineApplicationForm2.value['co_country'],
            Co_How_long_at_this_address: this.onlineApplicationForm2.value['co_howlong_at_this_address'],
            Co_Rent: this.onlineApplicationForm2.value['co_rent'],
            Co_Reason_for_moving: this.onlineApplicationForm2.value['co_reason_for_moving'],
            Co_Owner: this.onlineApplicationForm2.value['co_owner'],
            Co_Phone: this.onlineApplicationForm2.value['co_phone'],
            Co_Emergency_Contact_Name: this.onlineApplicationForm2.value['co_emergency_contact_name'],
            Co_Emergency_Contact_Phone: this.onlineApplicationForm2.value['co_emergency_contact_phone'],
            Co_Comments: this.onlineApplicationForm2.value['co_additional_comments'],
            Total_Adults: this.onlineApplicationForm3.value['total_adults'],
            Total_Children: this.onlineApplicationForm3.value['total_children'],
            Person1_Full_Name: this.onlineApplicationForm3.value['p1_full_name'],
            Person1_Age: this.onlineApplicationForm3.value['p1_age'],
            Person1_Relationship: this.onlineApplicationForm3.value['p1_relationship'],
            Person2_Full_Name: this.onlineApplicationForm3.value['p2_full_name'],
            Person2_Age: this.onlineApplicationForm3.value['p2_age'],
            Person2_Relationship: this.onlineApplicationForm3.value['p2_relationship'],
            Person3_Full_Name: this.onlineApplicationForm3.value['p3_full_name'],
            Person3_Age: this.onlineApplicationForm3.value['p3_age'],
            Person3_Relationship: this.onlineApplicationForm3.value['p3_relationship'],
            Person4_Full_Name: this.onlineApplicationForm3.value['p4_full_name'],
            Person4_Age: this.onlineApplicationForm3.value['p4_age'],
            Person4_Relationship: this.onlineApplicationForm3.value['p4_relationship'],
            Submit_Date: this.onlineApplicationForm4.value['submit_date'],
            application_attachments: this.progressInfos.map((element) => {
              return {
                keyPath: element.filename,
                doc_type: element.doc_type
              }
            }),
            Is_current_tenant: this.onlineApplicationForm1.value['current_tenant'],
            user_id: null,
            property_id: this.activatedRoute.snapshot.params.id ? this.activatedRoute.snapshot.params.id : null,
            Bank_ruptcy: null,
            Evicted: null,
            Evicted_Reason: null,
            Vehicle1_Make: null,
            Vehicle1_Model: null,
            Vehicle1_Year: null,
            Vehicle1_Licence: null,
            Vehicle2_Make: null,
            Vehicle2_Model: null,
            Vehicle2_Year: null,
            Vehicle2_Licence: null,
            Co_Bank_ruptcy: null,
            Co_Evicted: null,
            Co_Evicted_Reason: null,
            Co_Vehicle1_Make: null,
            Co_Vehicle1_Model: null,
            Co_Vehicle1_Year: null,
            Co_Vehicle1_Licence: null,
            Co_Vehicle2_Make: null,
            Co_Vehicle2_Model: null,
            Co_Vehicle2_Year: null,
            Co_Vehicle2_Licence: null,
            Assigned: null,
            Date: null,
            dl_image: null,
            pay_stub: null,
            tax_doc: null,
            li_form: null,
            child_support: null,
            spousal_support: null,
            unemployment: null,
            ss_document: null,
            section_paperwork: null,
            bank_statement: null,
            v3Token: token,
            status: 0,
          }
          // console.log(data)
          const payload = { ...this.clean(data), status: 0 }
          if(this.progressInfos.length === 0){
            
          }
          await this.onlineApplicationService.sendApplicaation(payload).toPromise().then((res) => {
            // console.log(res)
            const confirmData = {
              fname: data.name,
              lname: data.surname,
              address: data.address,
              email: data.username,
              phone: data.work_phone,
              city: data.city,
              state: data.state,
              zip: data.zipcode,
              property_id: res.body.data.createdData.property_id,
              application_id: res.body.data.createdData.id,
              applicant_id: res.body.data.createdData.user_id,
              is_co_applicant: this.isCoApplicat
            }
            // console.log(confirmData)
            this.spinner.hide();
            this.router.navigate([`applications/apply_online_confirmation`], { state: { data: confirmData } });
          }).catch((error) => {
            this.spinner.hide();
            console.log(error);
            this.showDanger(error.error.error);
          })
          // this.onlineApplicationService.sendApplicaation(payload).subscribe((result) => {
          //   console.log(result)

          // },
          //   (error) => {
          //     console.log(error)
          //   },
          //   () => {
          //     const confirmData = {
          //       fname: data.name,
          //       lname: data.surname,
          //       address: data.address,
          //       email: data.username,
          //       phone: data.Phone,
          //       city: data.city,
          //       state: data.state,
          //       zip: data.zipcode,
          //       // applicant_id: re
          //     }
          //     this.spinner.hide();
          //     // this.router.navigate([`applications/apply_online_confirmation`], { state: { data: confirmData } });
          //   }
          // )
        },
        error => {
          // console.log(`Recaptcha v3 error: see console`);
          console.log(`Recaptcha v3 error:`, error);
          this.spinner.hide();
        }
      );
      const win = this.responsiveService.getWindow()
      // if (win) {
      //   win.scrollTo({
      //     top: 0,
      //     left: 0,
      //     behavior: 'smooth'
      //   });
      // }

    } else {
      console.log('333')
      console.log( this.onlineApplicationForm4)
      // this.showDanger();
      this.onlineApplicationForm4.markAllAsTouched();
      const keys = Object.keys(this.onlineApplicationForm4.controls);
      for (const key of keys) {
        this.onlineApplicationForm4.get(key)?.markAsDirty();
      }
    }
    // this.step=this.step+1
    // window.scrollTo({
    //   top: 0, 
    //   left: 0, 
    //   behavior: 'smooth' 
    //  });
  }

  clean(obj: any) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] == "") {
        delete obj[propName];
      }
    }
    return obj
  }

  async onFileSelected(event: any) {
    console.log('fp1........')
    // if (event.target.files.length < 5) {
      console.log('fp22222........')
      // if (this.progressInfos.length < 5) {
        console.log('fp3333333........')
        for await (let item of event.target.files) {
          const selectedFile = item;
          console.log(selectedFile)
          this.selectedFiles = [...this.selectedFiles, selectedFile];
          this.progressInfos = [...this.progressInfos, { filename: selectedFile.name, doc_type: null, file_type: selectedFile.type, file_size: selectedFile.size, file_extention: selectedFile.name.split('.').pop(), file: selectedFile }]
          // this.progressInfos.push({ filename: selectedFile.name ,doc_type:null})
          // console.log(i)
        }
        console.log('after for........')
        

        const docData: any[] = [];
        this.spinner.show();
        try {
          let i = 0;
          for await (let element of this.progressInfos) {
            const term = this.onlineApplicationForm4.value['terms']
            if (this.onlineApplicationService.fileData[i]) {
              console.log('fp444444........')
              docData.push({
                index: i,
                value: this.onlineApplicationForm4.value[i],
                term: this.onlineApplicationForm4.value['terms']
              })
            } else {
              console.log('fp555555555........')
              this.onlineApplicationService.fileData[i] = [null, Validators.required]
              this.onlineApplicationForm4 = this.onlineApplicationService.getOnlineApplicationForm4(this.onlineApplicationService.fileData);
              this.onlineApplicationForm4.controls['submit_date'].setValue(this.submitDate)
              this.onlineApplicationForm4.controls['terms'].setValue(term)
              const fileInfo = {
                contentType: element.file_type,
                size: element.file_size,
                extension: element.file_extention,
              }
              try {
                
                const result = await this.onlineApplicationService.getPrisignUrl(fileInfo).toPromise();
                element.filename = result.body.data.key;
                await this.onlineApplicationService.callPrisignUrl(result.body.data.presignUploadURL, element.file, { 'Content-Type': element.file_type,'Accept':'*/*' }).toPromise();
              } catch (error) {
                this.spinner.hide()
                if(this.progressInfos.length === 1){
                  this.selectedFiles = []
                  this.progressInfos = []
                  delete this.onlineApplicationService.fileData[0]
                  delete this.onlineApplicationForm4.controls[0];
                  throw new Error('Somthing Went Wrong');
                } else {
                  await this.removeImage(i)
                }
                console.log(error)
              }
            }
            i++
          }
          console.log(i)
        } catch (error) {
          setTimeout(()=>{
            this.cd.detectChanges();
          },700)
          this.showDanger(`Somthing Went Wrong !
          Please Select File Again`);
        }
        
        // await Promise.all(
        //   this.progressInfos.map(async (element: any, i) => {
        //     const term = this.onlineApplicationForm4.value['terms']
        //     if (this.onlineApplicationService.fileData[i]) {
        //       console.log('fp444444........')
        //       docData.push({
        //         index: i,
        //         value: this.onlineApplicationForm4.value[i],
        //         term: this.onlineApplicationForm4.value['terms']
        //       })
        //     } else {
        //       console.log('fp555555555........')
        //       this.onlineApplicationService.fileData[i] = [null, Validators.required]
        //       this.onlineApplicationForm4 = this.onlineApplicationService.getOnlineApplicationForm4(this.onlineApplicationService.fileData);
        //       this.onlineApplicationForm4.controls['submit_date'].setValue(this.submitDate)
        //       this.onlineApplicationForm4.controls['terms'].setValue(term)
        //       const fileInfo = {
        //         contentType: element.file_type,
        //         size: element.file_size,
        //         extension: element.file_extention,
        //       }
        //       try {
                
        //         const result = await this.onlineApplicationService.getPrisignUrl(fileInfo).toPromise();
        //         element.filename = result.body.data.key;
        //         await this.onlineApplicationService.callPrisignUrl(result.body.data.presignUploadURL, element.file, { 'Content-Type': element.file_type,'Accept':'*/*' }).toPromise();

        //       } catch (error) {
        //         this.spinner.hide()
        //         if(this.progressInfos.length === 1){
        //           this.selectedFiles = []
        //           this.progressInfos = []
        //           delete this.onlineApplicationService.fileData[0]
        //           delete this.onlineApplicationForm4.controls[0];
        //           throw new Error('Somthing Went Wrong');
        //         } else {
        //           await this.removeImage(i)
        //         }
        //         // this.showDanger(error.error.error);
        //         // this.showDanger(`Somthing Went Wrong !
        //         // Please Remove Selected File ${this.progressInfos[i].filename} And Select File Again`);
        //         console.log(error)
        //       }
        //       // this.spinner.show()
        //       // const result = this.onlineApplicationService.getPrisignUrl(fileInfo).toPromise().then((result) => {
        //       //   element.filename = result.body.data.key
        //       //   this.onlineApplicationService.callPrisignUrl(result.body.data.presignUploadURL, element.file, { 'Content-Type': element.file_type,'Accept':'*/*' }).toPromise().then((result) => { /*console.log(result)*/this.spinner.hide() }).catch((err) => {
        //       //     // console.log('sdfs', err)
        //       //     this.spinner.hide()
        //       //     this.showDanger(`Somthing Went Wrong !
        //       //     Please Remove Selected File ${this.progressInfos[i].filename} And Select File Again`);
        //       //     console.log(err)
        //       //   })
        //       // }).catch((error) => {
        //       //   this.spinner.hide()
        //       //   // this.showDanger(error.error.error);
        //       //   this.showDanger(`Somthing Went Wrong !
        //       //   Please Remove Selected File ${this.progressInfos[i].filename} And Select File Again`);
        //       //   console.log(error)
        //       // })
        //     }
        //   })
        // ).catch(()=>{
        //   setTimeout(()=>{
        //     this.cd.detectChanges();
        //   },700)
        //   this.showDanger(`Somthing Went Wrong !
        //   Please Select File Again`);
        // })
        this.spinner.hide()
        docData.map((ele: any) => {
          this.onlineApplicationForm4.controls[ele.index].patchValue(ele.value,{eventEmmit : false});
          this.onlineApplicationForm4.controls['submit_date'].patchValue(this.submitDate ,{eventEmmit : false})
          this.onlineApplicationForm4.controls['terms'].patchValue(ele.term,{eventEmmit : false})
        })

        // this.onlineApplicationService.getPrisignUrl(data).subscribe()

        // if (this.documents) {
        //   this.documents.nativeElement.value = '';
        // }
      // }
    // }

  }

  async removeImage(index: any) {
    if (this.selectedFiles) {
      this.selectedFiles.splice(index, 1)
      this.progressInfos.splice(index, 1)
      // this.onlineApplicationForm4.controls[index].patchValue(null,{eventEmmit : false});
      delete this.onlineApplicationService.fileData[index];
      delete this.onlineApplicationForm4.controls[index];
      this.onlineApplicationForm4.updateValueAndValidity()
      this.cd.detectChanges();
      console.log(' this.selectedFiles ', this.selectedFiles)
      console.log(' this.progressInfos ', this.progressInfos)
      console.log(' this.onlineApplicationForm4.controls ', this.onlineApplicationForm4.controls)
      console.log('  this.onlineApplicationService.fileData ',  this.onlineApplicationService.fileData)
    }
  }

  public executeRecaptchaV3() {
    // console.log(`Recaptcha v3 execution requested...`);
    this.recaptchaV3Service.execute('submit').subscribe(
      token => {
        // console.log('Recaptcha v3 token', token);

      },
      error => {
        // console.log(`Recaptcha v3 error: see console`);
        console.log(`Recaptcha v3 error:`, error);
      }
    );
  }

  doc_type(event: any, index: any) {
    // console.log(index,processInfo.doc_type=event)
    this.progressInfos[index].doc_type = event.id
    // console.log(this.progressInfos)
  }

  previous() {
    this.step = this.step - 1
    const win = this.responsiveService.getWindow()
    if (win) {
      win.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  showSuccess() {
    this.toastService.show('Operation Successful', { classname: 'bg-success text-light', delay: 10000 });
  }

  showDanger(error:string) {
    if (!this.dangerTpl) return;
    this.toastService.show(error, { classname: 'bg-danger text-light', delay: 15000 });
  }

}
